import { useRoutes } from "@/contexts/use-routes"

const FALLBACK_BASE_PATH = "/tender"

/**
 * Tender module paths resolved from the route config rather than hardcoded, so
 * navigation follows the tenant's actual configured path — e.g. a tenant whose
 * route doc still mounts the module at the legacy /anbud path.
 */
export function useTenderPaths() {
  const { getRouteById } = useRoutes()
  const route = getRouteById("tender")
  const basePath = route?.path ?? FALLBACK_BASE_PATH
  const detailPath = (route?.overrides?.detailPath as string | undefined) ?? `${basePath}/:caseId`
  const casePath = (caseId: string) => detailPath.replace(":caseId", caseId)
  return { basePath, casePath }
}
